import { NotificationsAction } from "src/features/notifications/actions";
import { Notification } from "src/features/notifications/types";

const DEFAULT_TIMEOUT = 10 * 1000;

export function notificationsReducer(
	state: Notification[] = [],
	action: NotificationsAction
): Notification[] {
	if (action.type === "CREATE_NOTIFICATION") {
		return [
			{ ...action.payload, id: Date.now(), timeout: DEFAULT_TIMEOUT },
			...state
		];
	}
	if (action.type === "CLOSE_NOTIFICATION") {
		return state.filter(
			notification => notification.id !== action.payload.id
		);
	}
	return state;
}
